var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-page-outer-container" },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.$route.name === "client-roles"
        ? _c(
            "div",
            { staticClass: "data-table management-main-list-data-table" },
            [
              _c(
                "role-list",
                {
                  attrs: {
                    "pagination-from-parent": _vm.pagination,
                    "search-from-parent": _vm.search
                  },
                  on: {
                    "update-pagination": function($event) {
                      _vm.pagination = $event
                    },
                    "update-search": function($event) {
                      _vm.search = $event
                    }
                  }
                },
                [
                  _vm.isSuperAdmin || _vm.isAdmin
                    ? _c("management-add-button", {
                        attrs: {
                          label: _vm.$t("AddRole"),
                          disabled: !_vm.hasNeededPermissionsTo(
                            _vm.addButtonMissingPermissions
                          ),
                          "list-missing-permissions":
                            _vm.addButtonMissingPermissions
                        },
                        on: {
                          buttonClick: function($event) {
                            return _vm.$router.push({
                              name: "client-role-create"
                            })
                          }
                        }
                      })
                    : _c("div", { staticStyle: { height: "90px" } })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10baa8ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10baa8ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/ClientRoles/ClientRole.vue
// module id = null
// module chunks = 